import { Location } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PARAM_PATH } from '@navfleet/client/shared/constants/app';
import { logWarn } from '@navfleet/client/shared/util/log';
import { TranslationModule } from '@navfleet/shared/core/translation';

@Component({
    selector: 'fl-page-not-found',
    imports: [TranslationModule],
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
    private readonly location = inject(Location);
    private readonly route = inject(ActivatedRoute);

    public path: string | null = null;

    ngOnInit(): void {
        this.path = this.route.snapshot.paramMap.get(PARAM_PATH);
        if (!this.path) {
            this.path = this.location.path();
        }

        logWarn('PageNotFoundComponent', 'ngOnInit::page not found::', this.path);
    }
}
